module.exports = __webpack_public_path__ + "static/media/Bluelab pH Probe KCl Storage Solution - 120 ml.05f44f2f.webp";